import React, { useEffect, useState } from 'react';
import { Grid, makeStyles, OutlinedInput, TextField } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import queryString from 'query-string';
import axiosInstance, {
  // BCC_ADDR_EMAIL,
  BCC_ADDR_EMAIL_REG,
  emailValidation,
  EVENT_ID,
  EVENT_NAME,
  F_EMAIL,
  PAPERACCEPT_TEMPLATE,
  PAPERGUIDE_TEMPLATE,
  PAPERSUBMIT_TEMPLATE,
  PAYCOMPLETE_TEMPLATE,
  REGISTRAIONSUBMIT_TEMPLATE,
  SPONSORSUBMIT_TEMPLATE,
  SPONSORCOMPLETE_TEMPLATE,
  WEB_API,
} from '../constatns';
import Button from '@material-ui/core/Button';
import swal from '@sweetalert/with-react';

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#fff',
    padding: 20,
    '& p': {
      display: 'inline',
    },
  },
  idBox: {
    border: '1px solid #000',
    padding: 10,
    fontWeight: 'bold',
  },
}));

const ResendPage = (props) => {
  const { history, theme } = props;
  const classes = useStyles();
  const [htmlData, setHtmlData] = useState('');
  const [to, setTo] = useState('');

  const getEmailData = () => {
    const type = queryString.parse(props.location.search)['type'];
    const id = queryString.parse(props.location.search)['id'];

    console.log(type, id);
    let url = `${WEB_API}/${type}/previewEmail?evt=${EVENT_ID}&${type}Id=${id}&evtName=${EVENT_NAME}&file=${type}Submit`;
    // 2022 custom :: 등록완료메일 재전송 미리보기 양식 등록언어별로 불러오기
    if (type === 'registration') {
      // url = `${WEB_API}/${'user'}/previewEmail?evt=${EVENT_ID}&${'user'}Id=${id}&evtName=${EVENT_NAME}&file=${type}Submit`;
      url = `${WEB_API}/${'user'}/previewEmail?evt=${EVENT_ID}&${'user'}Id=${id}&evtName=PRS2021&file=${type}Submit`;
    } else if (type === 'registrationKor') {
      url = `${WEB_API}/${'user'}/previewEmail?evt=${EVENT_ID}&${'user'}Id=${id}&evtName=PRS2021&file=registrationSubmitKor`;
    } else if (type === 'payComplete') {
      url = `${WEB_API}/${'user'}/previewEmail?evt=${EVENT_ID}&${'user'}Id=${id}&evtName=PRS2021&file=payComplete`;
    }
    if (type === 'dinnerSubmit') {
      url = `${WEB_API}/${'user'}/previewEmail?evt=${EVENT_ID}&${'user'}Id=${id}&evtName=PRS2022&file=galaSubmitKor`;
    }
    //
    else if (type === 'paper') {
      url = `${WEB_API}/${'paper'}/previewEmail?evt=${EVENT_ID}&${'paper'}Id=${id}&evtName=PRS2021&file=paperSubmit`;
    } else if (type === 'paperReject') {
      // * 2022 CUSTOM 초록제출 미채택  이메일 발송 미리보기
      url = `${WEB_API}/${'paper'}/previewEmail?evt=${EVENT_ID}&${'paper'}Id=${id}&evtName=PRS2022&file=paperReject`;
    } else if (type === 'paperAccept') {
      // const file = 'PRS2021/TYPE_Accept_LANG.html';
      // url = `${WEB_API}/${'paper'}/previewEmailAccept?evt=${EVENT_ID}&${'paper'}Id=${id}&evtName=${EVENT_NAME}&file=${file}`;
      url = `${WEB_API}/${'paper'}/previewEmailAccept?evt=${EVENT_ID}&${'paper'}Id=${id}&evtName=PRS2021&file=PRS2021/TYPE_Accept_LANG.html`;
    } else if (type === 'paperGuide') {
      // const file = 'PRS2021/TYPE_Guideline_LANG.html';
      // url = `${WEB_API}/${'paper'}/previewEmailAccept?evt=${EVENT_ID}&${'paper'}Id=${id}&evtName=${EVENT_NAME}&file=${file}`;
      url = `${WEB_API}/${'paper'}/previewEmailAccept?evt=${EVENT_ID}&${'paper'}Id=${id}&evtName=PRS2021&file=PRS2021/TYPE_Guideline_LANG.html`;
    }
    //
    else if (type === 'sponsor') {
      url = `${WEB_API}/${type}/previewEmail?evt=${EVENT_ID}&${type}Id=${id}&evtName=${EVENT_NAME}&file=${type}Submit_i.html`;
    } else if (type === 'sponsorComplete') {
      url = `${WEB_API}/${'sponsor'}/previewEmail?evt=${EVENT_ID}&${'sponsor'}Id=${id}&evtName=${EVENT_NAME}&file=sponsorComplete.html`;
    } else if (type === 'speaker') {
      url = `${WEB_API}/${'speaker'}/previewEmail?evt=${EVENT_ID}&${'speaker'}Id=${id}&evtName=PRS2021&file=${type}Submit`;
    } else if (type === 'dinner') {
      url = `${WEB_API}/${'dinner'}/previewEmail?evt=${EVENT_ID}&${'dinner'}Id=${id}&${EVENT_NAME}&file=${type}Submit`;
    }

    axiosInstance.get(url).then((res) => {
      // console.log(res);
      setHtmlData(res.data);
    });
  };

  useEffect(() => {
    getEmailData();
  }, []);

  const sendEmail = () => {
    let type = queryString.parse(props.location.search)['type'];
    const id = queryString.parse(props.location.search)['id'];
    let toEmail = '';
    if (to) {
      if (emailValidation(to)) {
        toEmail = to;
      } else {
        swal('이메일형식을 확인해주세요.');
        return;
      }
    }
    let tempName = '';
    if (type === 'paper') tempName = PAPERSUBMIT_TEMPLATE;
    if (type === 'sponsor') tempName = SPONSORSUBMIT_TEMPLATE;
    if (type === 'speaker') tempName = 'SpeakerSubmitPRS2021';
    let apiUrl = `${WEB_API}/${type}/${type}SubmitEmail?evt=${EVENT_ID}&${type}Id=${id}&toEmail=${toEmail}&templateName=${tempName}&from=${F_EMAIL}`;

    if (type === 'registration' || type === 'registrationKor') {
      tempName = REGISTRAIONSUBMIT_TEMPLATE;
      // apiUrl = `${WEB_API}/user/${type}SubmitEmail?evt=${EVENT_ID}&${'user'}Id=${id}&toEmail=${toEmail}&templateName=${tempName}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL.toString()}`;
      // apiUrl = `${WEB_API}/user/${type}SubmitEmail?evt=${EVENT_ID}&${'user'}Id=${id}&toEmail=${toEmail}&templateName=${tempName}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL_REG.toString()}`;
      apiUrl = `${WEB_API}/user/registrationSubmitEmail?evt=${EVENT_ID}&${'user'}Id=${id}&toEmail=${toEmail}&templateName=${tempName}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL_REG.toString()}`;
    } else if (type === 'payComplete') {
      tempName = PAYCOMPLETE_TEMPLATE;
      // apiUrl = `${WEB_API}/user/payCompleteEmail?evt=${EVENT_ID}&${'user'}Id=${id}&toEmail=${toEmail}&templateName=${tempName}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL.toString()}`;
      apiUrl = `${WEB_API}/user/payCompleteEmail?evt=${EVENT_ID}&${'user'}Id=${id}&toEmail=${toEmail}&templateName=${tempName}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL_REG.toString()}`;
    } else if (type === 'paperAccept') {
      tempName = PAPERACCEPT_TEMPLATE;
      // apiUrl = `${WEB_API}/paper/paperAcceptEmailSend?evt=${EVENT_ID}&${'paper'}Id=${id}&toEmail=${toEmail}&templateName=${tempName}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL.toString()}`;
      apiUrl = `${WEB_API}/paper/paperAcceptEmailSend?evt=${EVENT_ID}&${'paper'}Id=${id}&toEmail=${toEmail}&templateName=${tempName}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL_REG.toString()}`;
    } else if (type === 'paperGuide') {
      tempName = PAPERGUIDE_TEMPLATE;
      // apiUrl = `${WEB_API}/paper/paperAcceptEmailSend?evt=${EVENT_ID}&${'paper'}Id=${id}&toEmail=${toEmail}&templateName=${tempName}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL.toString()}`;
      apiUrl = `${WEB_API}/paper/paperAcceptEmailSend?evt=${EVENT_ID}&${'paper'}Id=${id}&toEmail=${toEmail}&templateName=${tempName}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL_REG.toString()}`;
    } else if (type === 'paperReject') {
      // * 2022 CUSTOM 초록제출 미채택  이메일 발송 *
      apiUrl = `${WEB_API}/paper/paperSubmitEmailWithTemplateName?evt=${EVENT_ID}&${'paper'}Id=${id}&toEmail=${toEmail}&templateName=${'PaperRejectPRS'}&from=${F_EMAIL}`;
    } else if (type === 'sponsorComplete') {
      // * 2022 CUSTOM 스폰서 후원신청 완료 이메일 발송=> 기존에 생성되어 있으나 미사용 중인 templateName 재활용 *
      apiUrl = `${WEB_API}/sponsor/sponsorSubmitEmail?evt=${EVENT_ID}&${'sponsor'}Id=${id}&toEmail=${toEmail}&templateName=${'WelcomeKSIN'}&from=${F_EMAIL}`;
    } else if (type === 'dinnerSubmit') {
      apiUrl = `${WEB_API}/user/dinnerEmail?evt=${EVENT_ID}&userId=${id}&toEmail=${toEmail}&templateName=${'DinnerWaitPRS2022'}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL_REG.toString()}`;
    } else if (type === 'dinnerComplete') {
      apiUrl = `${WEB_API}/user/dinnerEmail?evt=${EVENT_ID}&userId=${id}&toEmail=${toEmail}&templateName=${'DinnerCompletePRS2022'}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL_REG.toString()}`;
    }

    axiosInstance.post(apiUrl).then((res) => {
      console.log(res, 'res');
      swal('이메일을 발송하였습니다.').then(() => {
        window.opener = 'Self';
        window.open('', '_parent', '');
        window.close(); // 일반적인 현재 창 닫기
        window.open('about:blank', '_self').self.close(); // IE에서 묻지 않고 창 닫기
      });
    });
  };

  return (
    <Grid container className={classes.root}>
      <CssBaseline />
      {htmlData && (
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={12}>
            <div dangerouslySetInnerHTML={{ __html: htmlData }} />
          </Grid>
          <Grid item xs={12} style={{ width: '100%', marginTop: 20, marginBottom: 10, borderTop: `2px solid #194579` }}>
            <Grid container justifyContent={'center'} alignItems={'center'} style={{ marginTop: 20 }} spacing={2}>
              <Grid item xs={2} style={{ textAlign: 'right' }}>
                발송이메일 :
              </Grid>
              <Grid item xs={8}>
                <OutlinedInput
                  style={{ width: '100%' }}
                  onChange={(e) => {
                    setTo(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <Button variant={'contained'} color={'primary'} onClick={sendEmail}>
                  SEND
                </Button>
              </Grid>
            </Grid>
            <Grid container direction="column" justifyContent="center" alignItems="center">
              <Grid item xs={1}>
                &nbsp;
              </Grid>
              <Grid item xs={11} style={{ paddingTop: 10, color: 'red' }}>
                ※ 발송 이메일 입력하지 않고 메일 발송 버튼 클릭 시 접수자에게 메일이 발송됩니다.
                <br />※ 발송 이메일 입력 후 메일 발송 클릭 시 입력한 메일 계정으로만 메일이 발송 됩니다.
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default ResendPage;
